module.exports = __webpack_public_path__ + "static/line1_9-ff4bc66c641ff592a4a6dd6078b31fa7.jpg";